import { render, staticRenderFns } from "./institutional.vue?vue&type=template&id=8575ab14&scoped=true"
import script from "./institutional.vue?vue&type=script&lang=js"
export * from "./institutional.vue?vue&type=script&lang=js"
import style0 from "./institutional.vue?vue&type=style&index=0&id=8575ab14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8575ab14",
  null
  
)

export default component.exports